import type { AssetTypeEntity } from "@/entities/asset-type";

import { useReferentialAssetTypeCategories } from "@/entities/referential/referential-asset-type-categories";

import { getAssetTypeCategory } from "./asset-type-category.helper";

export const useAssetTypeCategory = (assetType?: AssetTypeEntity) => {
  const { assetTypeCategories } = useReferentialAssetTypeCategories();

  return getAssetTypeCategory(assetType, assetTypeCategories);
};
